import { lenisRef } from "@/lib/nav";

export const StoryChapters = ({ sections }) => {
  const jumpTo = (id) => {
    const heading = document.getElementById(`story-heading-${id}`);
    const navigation = document.querySelector('[data-testid="apparition-reading-navigation"]');
    if (!heading || !navigation) return;
    const top = Number.parseFloat(getComputedStyle(navigation).top) || 0;
    const offset = -(top + navigation.getBoundingClientRect().height + 24);
    const focusHeading = () => heading.focus({ preventScroll: true });
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (lenisRef.current) {
      // Account for newly rendered story length before starting a chapter jump.
      lenisRef.current.resize();
      lenisRef.current.scrollTo(heading, { offset, immediate: reducedMotion, duration: 0.7, force: true, onComplete: focusHeading });
    } else {
      window.scrollTo({ top: heading.getBoundingClientRect().top + window.scrollY + offset, behavior: "instant" });
      focusHeading();
    }
  };

  return <nav aria-label="Full story chapters" data-testid="story-chapter-navigation" className="mt-8 border-y border-marian/15 py-5">
    <p data-testid="story-chapters-label" className="text-xs font-semibold text-slateblue">In this account</p>
    <ol className="mt-3 grid gap-1 sm:grid-cols-2">{sections.map((section, i) => <li key={section.id} className="min-w-0">
      <button type="button" data-testid={`story-jump-${section.id}`} onClick={() => jumpTo(section.id)} className="flex min-h-11 w-full items-start gap-3 rounded px-2 py-2 text-left text-sm text-marian transition-colors hover:bg-paleblue focus-visible:outline focus-visible:outline-2 focus-visible:outline-marian">
        <span aria-hidden="true" className="mt-0.5 shrink-0 font-mono text-[10px] text-gold">{String(i + 1).padStart(2, "0")}</span><span>{section.title}</span>
      </button>
    </li>)}</ol>
  </nav>;
};